var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Socket test - watch console logs "),_c('button',{on:{"click":_vm.test}},[_vm._v("start test")])])}
var staticRenderFns = []

export { render, staticRenderFns }